
























import { computed, defineComponent, getCurrentInstance, onUnmounted, ref } from "@vue/composition-api";
import { Page } from "@scrile/api-provider/dist/api/PageProvider";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import config from "@/config";
import { HideMenuHandlerData } from "@/types";
import { EVENTS } from "@/const";

export default defineComponent({
  name: "BaseFooter",
  setup() {
    const vm = getCurrentInstance();
    const pages = ref<Page[]>([]);
    const isSoloCreator = computed<boolean>(() => !!config.soloCreatorId);
    const visiblePages = computed(() => pages.value.filter((page: Page) => page.visible));
    const hideFooterForSolo = computed(() => (isSoloCreator.value ? !!vm?.$route.meta?.login : false));
    const isLogged = computed<boolean>(() => !!vm?.$store.state.user);

    const getPages = async (): Promise<void> => {
      pages.value = await providers.PageProvider.find();
    };

    if (isSoloCreator.value) {
      getPages();
    }

    const hideFooter = ref<boolean>(false);
    const hideFooterHandler = (hideMenuHandlerData: HideMenuHandlerData | boolean) => {
      if (typeof hideMenuHandlerData === "boolean") {
        return (hideFooter.value = hideMenuHandlerData);
      }
      if (hideMenuHandlerData.hide !== undefined && hideMenuHandlerData.fullHide !== undefined) {
        hideFooter.value = hideMenuHandlerData.hide || hideMenuHandlerData.fullHide;
      } else {
        if (hideMenuHandlerData.hide !== undefined) {
          hideFooter.value = hideMenuHandlerData.hide;
        }
        if (hideMenuHandlerData.fullHide !== undefined) {
          hideFooter.value = hideMenuHandlerData.fullHide;
        }
      }
    };

    emitter.on<any>(EVENTS.MAIN_MENU_HIDE, hideFooterHandler);
    onUnmounted(() => emitter.off<any>(EVENTS.MAIN_MENU_HIDE, hideFooterHandler));

    return {
      isSoloCreator,
      visiblePages,
      hideFooter,
      hideFooterForSolo,
      isLogged,
    };
  },
});
